import React from 'react';
import { TextField } from '@mui/material';

export default function AdditionalKwargsField({
  value,
  onChange,
  disabled = false,
}) {
  return (
    <TextField
      label='Additional Args (override)'
      value={value || ''}
      onChange={(e) => onChange(e.target.value)}
      fullWidth
      disabled={disabled}
      multiline
      minRows={2}
      placeholder='Example: --max-model-len 185504'
    />
  );
}

